import styled from 'styled-components'

export const InputWrapper = styled.div`
  padding-bottom: 10px;
`
